import { render, staticRenderFns } from "./ExchChooser.vue?vue&type=template&id=62881fa9&scoped=true"
import script from "./ExchChooser.vue?vue&type=script&lang=js"
export * from "./ExchChooser.vue?vue&type=script&lang=js"
import style0 from "./ExchChooser.vue?vue&type=style&index=0&id=62881fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62881fa9",
  null
  
)

export default component.exports